export const gaTracking = (eventName, params) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};



// WEBPACK FOOTER //
// ./src/modules/ga.js